function checkLangPopupState() {
  const STORAGE_KEY = "lang-popup-shown";
  const $popup = $("#aplenglowee-lang-pop");

  if (!$popup.length) return;

  // 判斷這個分頁工作階段是否已顯示過
  const hasShownPopup = sessionStorage.getItem(STORAGE_KEY);

  if (!hasShownPopup) {
    // 顯示 popup
    $popup.prop("hidden", false);
  }
}

function closeLangPopup() {
  const STORAGE_KEY = "lang-popup-shown";

  // 記錄已顯示
  sessionStorage.setItem(STORAGE_KEY, "true");

  const $popup = $("#aplenglowee-lang-pop");
  $popup.prop("hidden", true);
}

$(document).ready(function () {
  checkLangPopupState();
});
